import { tracs_api, tracs_api_bg } from "../../services/api.interceptor";

class ReportService{
    
    getReports(tocIds:number[],ticketTypes:number[], includestationSpecific:boolean){
        let data={TocIds:tocIds,TicketTypes:ticketTypes,IncludeStationSpecific:includestationSpecific};
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Reports/GetReports",data);
        
    }

    getReportDownload(reporId:string,tocIds:number[],nlcIds:number[]){
        let data={Id:reporId,TocIds:tocIds,Stations:nlcIds}
        
        return tracs_api_bg
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Reports/DownloadReport",data,{
            responseType:"arraybuffer"
            
        });
    }
}

export default new ReportService();